var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex w-full h-full"},[_c('img',{staticClass:"rounded object-scale-down border-2",attrs:{"src":_vm.image}}),_c('button',{staticClass:"button absolute top-0 right-0 m-3",on:{"click":_vm.onModalClose}},[_c('i',{staticClass:"far fa-times",attrs:{"aria-hidden":"true"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }